import React, { useEffect, useState } from 'react'
import { Input } from 'components/Input'
import {
  BillingCardCardError,
  BillingCardLogo,
} from 'pages/ClientProfile/BillingInformation/BillingInformation.styled'
import { CardFormContainer, RowContent, ColumnContent, ColumnButtonContent } from './CardForm.styled'
import Visa from 'assets/icons/visa.svg'
import Mastercard from 'assets/icons/mastercard.svg'
import Discover from 'assets/icons/discover.svg'
import Amex from 'assets/icons/amex.svg'
import { cardPrefixes } from 'utils/credit-card-prefixes'
import Button from 'components/Button/Button'

function CardForm() {
  const [cardNumber, setCardNumber] = useState<string>()
  const [maxLength, setMaxLength] = useState<number>(16)
  const [activeCard, setActiveCard] = useState<
    'visa' | 'amex' | 'discover' | 'mastercard' | null
  >(null)
  const [valid, setValid] = useState<boolean | null>(null)

  useEffect(() => {
    if (cardNumber) {
      determineType()
      if (cardNumber.length === maxLength) {
        setValid(verifyNumber())
      } else {
        setValid(false)
      }
    }

    if (cardNumber === '') {
      setActiveCard(null)
      setValid(false)
    }
    if (activeCard === 'amex') {
      setMaxLength(15)
    } else {
      setMaxLength(16)
    }
  }, [cardNumber])

  const verifyNumber = (): boolean | null => {
    let sum = 0
    let temp = 0
    if (cardNumber) {
      const cardNumberCopy = cardNumber
      const checkDigit = parseInt(cardNumber.slice(-1))
      const parity = cardNumberCopy.length % 2
      for (let i = 0; i <= cardNumberCopy.length - 2; i++) {
        if (i % 2 === parity) {
          temp = +cardNumberCopy[i] * 2
        } else {
          temp = +cardNumberCopy[i]
        }

        if (temp > 9) {
          temp -= 9
        }
        sum += temp
      }
      return (sum + checkDigit) % 10 === 0
    }
    return null
  }

  const determineType = () => {
    //@ts-ignore
    for (const key of cardPrefixes) {
      for (const value of key[1]) {
        if (cardNumber && cardNumber.startsWith(value)) {
          switch (key[0]) {
            case 'visa':
              setActiveCard('visa')
              break
            case 'mastercard':
              setActiveCard('mastercard')
              break
            case 'discover':
              setActiveCard('discover')
              break
            case 'amex':
              setActiveCard('amex')
              break
            default:
              break
          }
          return
        } else {
          setActiveCard(null)
        }
      }
    }
  }

  return (
    <CardFormContainer>
      <div>
        <Input
          required
          label={'Name on card'}
          style={{ textTransform: 'uppercase' }}
        // RightIcon={valid && Check}
        />
      </div>
      <Input
        required
        label={'Card Number'}
        onTextChange={setCardNumber}
        type={'number'}
        format={'#### #### #### ####'}
        mask="_"
      // RightIcon={valid && Check}
      />
      {cardNumber && !valid && (
        <BillingCardCardError>
          Invalid credit card number
        </BillingCardCardError>
      )}
      <div style={{ display: 'flex' }}>
        <BillingCardLogo src={Visa} active={activeCard === 'visa'} />
        <BillingCardLogo
          src={Mastercard}
          active={activeCard === 'mastercard'}
        />
        <BillingCardLogo src={Discover} active={activeCard === 'discover'} />
        <BillingCardLogo src={Amex} active={activeCard === 'amex'} />
      </div>
      <div>
        <RowContent>
          <ColumnContent>
            <Input
              required
              label={'Expiration Date'}
              format="##/##"
              mask={['_', '_', '_', '_']}
            // RightIcon={valid && Check}
            />
          </ColumnContent>
          <ColumnContent>
            <Input
              required
              label={'CVC'}
              format="###"
              mask={'_'}
            // RightIcon={valid && Check}
            />
          </ColumnContent>
          <ColumnButtonContent>
            <Button
              disabled
              text="Add card"
              variant="primary"
              preset="filled"
              size={'small'}
            />
          </ColumnButtonContent>
        </RowContent>
      </div>

    </CardFormContainer>
  )
}

export default CardForm
